import React, { useState, useEffect } from 'react'
import moment from 'moment'
import {
  CustomerDocument,
  useCustomerUpdateMutation,
  CustomerUpdateInput,
  CustomerQuery,
} from 'lib/graphql/storeadmin'
import {
  Select,
  showMessage,
  Spin,
  Button,
  Paragraph,
  Title,
  Card,
} from 'components/common'

type Props = {
  customer: CustomerQuery['customer']
}

export const PrefecturalGroupFlag: React.FC<Props> = (props) => {
  const { customer } = props
  const [flag, setFlag] = useState<boolean>(false)
  const [disabled, setDisabled] = useState<boolean>(false)
  const [updateCustomer, { loading: customerUpdateLoading }] =
    useCustomerUpdateMutation({
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: CustomerDocument,
          variables: {
            id: customer?.id,
            future: moment().format('YYYY-MM-DD'),
          },
        },
      ],
    })
  const handleUpdate = async (id: string) => {
    // 初期値から変化なしなら処理を中止する
    if (
      flag ===
      customer.metaFields.edges.some(
        ({ node }) => node.key === 'local-organization'
      )
    )
      return

    const input: CustomerUpdateInput = {
      subArenaBookableFlag: customer.metaFields.edges.some(
        ({ node }) => node.key === 'subarena-permitted'
      ),
      prefecturalGroupFlag: flag,
    }

    // 顧客詳細ページでは重複チェックを行わないため、allowDuplicateはtrueにする
    const allowDuplicate = true
    try {
      const { data } = await updateCustomer({
        variables: { allowDuplicate, id, input },
      })
      if (data) {
        showMessage('success', '県内団体フラグを更新しました')
      }
    } catch (e) {
      console.log(e)
      showMessage('error', 'データの更新に失敗しました')
    }
  }

  useEffect(() => {
    if (!customer) return
    setFlag(
      customer.metaFields.edges.some(
        ({ node }) => node.key === 'local-organization'
      )
    )
    setDisabled(
      !customer.metaFields.edges.some(
        ({ node }) => node.key === 'subarena-permitted'
      )
    )
  }, [customer])

  return (
    <Card shadow>
      <Title level={5}>県内団体フラグの設定</Title>
      <Paragraph mute>
        県内/県外の団体か設定できます。
        <br />
        県内団体の場合は通常とは異なる期間でSAGAアリーナ内の施設を予約することができるようになります。
      </Paragraph>
      <Paragraph mute>
        ※サブアリーナ予約可能フラグを予約可能にすることで設定できます。
      </Paragraph>
      <Spin tip="Loading" size="large" spinning={customerUpdateLoading}>
        <div className="grid grid-cols-3 gap-4">
          <Select
            disabled={disabled}
            value={flag}
            onChange={setFlag}
            className="col-span-2"
            options={[
              { value: true, label: '県内団体' },
              { value: false, label: '県外団体' },
            ]}
          />
          <Button
            disabled={disabled}
            type="primary"
            onClick={() => handleUpdate(customer.id)}
          >
            更新
          </Button>
        </div>
      </Spin>
    </Card>
  )
}
